const Progress = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_1526_14389)">
      <path
        d="M15.364 48.9102H2.45673C1.42123 48.9102 0.581726 49.7497 0.581726 50.7852V62.1252C0.581726 63.1607 1.42123 64.0002 2.45673 64.0002H17.2391V50.7852C17.239 49.7497 16.3996 48.9102 15.364 48.9102Z"
        fill="currentColor"
      />
      <path
        d="M33.8954 38.4102H22.863C21.8275 38.4102 20.988 39.2497 20.988 40.2852V64.0002H35.7704V40.2852C35.7704 39.2497 34.9309 38.4102 33.8954 38.4102Z"
        fill="currentColor"
      />
      <path
        d="M59.7229 10.1263L63.5017 6.025C64.0067 5.4775 64.1392 4.68375 63.8404 4.0025C63.5417 3.32 62.8679 2.88 62.1229 2.88H50.0355V1.875C50.0355 0.84 49.1968 0 48.1605 0C47.1255 0 46.2855 0.84 46.2855 1.875V23.75H41.3943C40.3588 23.75 39.5193 24.5895 39.5193 25.625V64H54.6204C55.6567 64 56.4954 63.16 56.4954 62.125V25.625C56.4954 24.59 55.6567 23.75 54.6204 23.75H50.0355V17.0413H62.1229C62.8817 17.0413 63.5654 16.5837 63.8554 15.8825C64.1454 15.1812 63.9842 14.3737 63.4467 13.8387L59.7229 10.1263Z"
        fill="currentColor"
      />
      <path
        d="M31.819 16.0984C32.2791 17.0262 33.4038 17.4052 34.3317 16.9452C35.2595 16.4851 35.6386 15.3601 35.1785 14.4323C31.7792 7.5777 32.1231 8.2687 32.0737 8.17557C31.7213 7.50982 30.9963 7.10782 30.2242 7.18782C30.219 7.18832 30.2136 7.18945 30.2082 7.19007C30.0548 7.20732 30.4645 7.12695 23.3627 8.62145C22.3493 8.8347 21.7008 9.82907 21.914 10.8424C22.0998 11.7256 22.879 12.3317 23.7468 12.3317C24.0078 12.3317 23.8397 12.3533 27.1373 11.6593C24.6786 16.4856 21.4785 20.8838 17.5923 24.7702C12.8295 29.5332 7.29572 33.2673 1.14485 35.8688C0.191098 36.2723 -0.255027 37.3723 0.148348 38.3261C0.551973 39.2807 1.6526 39.7257 2.6056 39.3227C9.20347 36.5321 15.1378 32.5281 20.2438 27.4218C24.4055 23.2602 27.8345 18.5496 30.4705 13.3796L31.819 16.0984Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1526_14389">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Progress;
